import type { ResolvedRef } from './resolve';

const DEFAULT_TTL_MS = 10 * 60 * 1000;

type Entry = {
  ref: ResolvedRef;
  expiresAt: number;
};

const store = new Map<string, Entry>();
let counter = 0;

function evictExpired(now = Date.now()): void {
  for (const [id, entry] of store.entries()) {
    if (entry.expiresAt <= now) store.delete(id);
  }
}

export function registerHandle(ref: ResolvedRef, ttlMs: number = DEFAULT_TTL_MS): string {
  evictExpired();
  counter += 1;
  const id = `h_${counter.toString(36)}`;
  store.set(id, { ref, expiresAt: Date.now() + ttlMs });
  return id;
}

export function getHandle(id: string): ResolvedRef | null {
  evictExpired();
  return store.get(id)?.ref ?? null;
}

export function dropHandle(id: string): boolean {
  return store.delete(id);
}

export function clearAllHandles(): void {
  store.clear();
}

export function debugHandleCount(): number {
  evictExpired();
  return store.size;
}
